import { Box } from "@outschool/backpack";
import {
  ActivityEnrollableTimesModal_ActivityFragment,
  ClassDetailsNoSectionsQuery,
  ClassDetailsQuery_ActivityFragment
} from "@outschool/gql-frontend-generated";
import { useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import { useShowCredits } from "@outschool/ui-components-website";
import React from "react";

import { AskAQuestionButton } from "./ctas/AskAQuestionButton";
import MobileSeeScheduleButton from "./ctas/MobileSeeScheduleButton";
import TutorEnrollButtonAndModal from "./ctas/TutorEnrollButtonAndModal";
import useTutoringFlow from "./hooks/useTutoringFlow";
import MobileActivityCredits from "./subcomponents/MobileActivityCredits";
import MobileActivityPrice from "./subcomponents/MobileActivityPrice";

export default function MobileStickyFooter({
  activity,
  isLoadingOneOnOneAvailabilities,
  hasOneOnOneAvailabilities = false,
  activityWithEnrollableTimes,
  leader,
  setIsAvailabilityModalOpen
}: {
  activity: ClassDetailsQuery_ActivityFragment;
  isLoadingOneOnOneAvailabilities: boolean;
  hasOneOnOneAvailabilities?: boolean;
  activityWithEnrollableTimes?: ActivityEnrollableTimesModal_ActivityFragment;
  leader: ClassDetailsNoSectionsQuery["activity"]["leader"];
  setIsAvailabilityModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const { t } = useTranslation(
    "client\\components\\detailPage\\MobileStickyFooter"
  );
  const { isLoggedIn } = useSession();
  const showCredits = useShowCredits();
  const { tutoringShowAvailableTimesInline } = useTutoringFlow();

  return (
    <Box
      flex
      sx={{
        width: "100%",
        zIndex: 1000,
        backgroundColor: "white",
        padding: "1em",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow:
          "0px -8px 16px 0px rgba(0, 0, 0, 0.08), 0px 0px 4px 0px rgba(0, 0, 0, 0.04);",
        borderTop: "1px solid",
        borderColor: "grey.200",
        position: "fixed",
        bottom: 0,
        transition: "all 0.3s ease-in-out",
        columnGap: "1em"
      }}
    >
      {showCredits ? (
        <MobileActivityCredits activity={activity} />
      ) : (
        <MobileActivityPrice activity={activity} />
      )}
      <Box sx={{ display: "flex", justifyContent: "space-between", gap: 10 }}>
        {hasOneOnOneAvailabilities && !tutoringShowAvailableTimesInline ? (
          <TutorEnrollButtonAndModal
            activity={activity}
            buttonText={t("See Schedule")}
            buttonSize={"small"}
            activityWithEnrollableTimes={activityWithEnrollableTimes}
          />
        ) : (
          <MobileSeeScheduleButton
            activity={activity}
            isLoadingOneOnOneAvailabilities={isLoadingOneOnOneAvailabilities}
            hasOneOnOneAvailabilities={hasOneOnOneAvailabilities}
            setIsAvailabilityModalOpen={setIsAvailabilityModalOpen}
          />
        )}
        {isLoggedIn && (
          <AskAQuestionButton
            activity={activity}
            leader={leader}
            buttonSize={"small"}
            useIconOnly={true}
          />
        )}
      </Box>
    </Box>
  );
}
